import Link from 'next/link';

export default function FooterSection() {
  const currentYear = new Date()?.getFullYear();

  return (
    <footer style={{ backgroundColor: '#272727', color: '#fff' }}>
      {/* Teal top accent line */}
      <div className="h-1" style={{ backgroundColor: '#009688' }} />

      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-10 mb-10">
          {/* Brand column */}
          <div>
            <div className="mb-5">
              <Link
                href="/landing-page"
                aria-label="GestPub, Gestão Pública e Consultoria Autárquica, Página inicial"
                className="inline-block focus-visible:outline-none">

                <img
                  src="/assets/images/5-1773845112159.png"
                  alt="GestPub — Gestão Pública e Consultoria Autárquica"
                  style={{ height: 42, width: 'auto', display: 'block', flexShrink: 0, mixBlendMode: 'screen' }} />

              </Link>
            </div>
            <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.82rem', color: 'rgba(255,255,255,0.55)', marginBottom: '1.25rem' }}>
              O GP Otimiza é o serviço da GestPub dedicado ao diagnóstico e modernização organizacional de municípios portugueses. A GestPub apoia autarquias a melhorar a eficiência interna e a capacidade de execução através de intervenções pragmáticas, discretas e orientadas para resultados.
            </p>
            <div className="flex gap-2">
              {[
              {
                label: 'Facebook',
                href: 'https://www.facebook.com/gestpubconsult/',
                icon:
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
                    </svg>

              },
              {
                label: 'LinkedIn',
                href: 'https://www.linkedin.com/company/gestpub-gest%C3%A3o-p%C3%BAblica-consultoria-aut%C3%A1rquica/',
                icon:
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" />
                      <circle cx="4" cy="4" r="2" />
                    </svg>

              },
              {
                label: 'Instagram',
                href: 'https://www.instagram.com/gestpub.pt/',
                icon:
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                      <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" fill="#272727" />
                      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" stroke="#272727" strokeWidth="2" />
                    </svg>

              }]?.
              map((social) =>
              <a
                key={social?.label}
                href={social?.href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center transition-colors duration-200"
                style={{
                  borderRadius: '5px',
                  border: '1px solid rgba(255,255,255,0.2)',
                  color: 'rgba(255,255,255,0.5)'
                }}
                onMouseEnter={(e) => e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)'}
                onMouseLeave={(e) => e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)'}
                aria-label={social?.label}>

                  {social?.icon}
                </a>
              )}
            </div>
          </div>

          {/* Navigation column */}
          <div>
            <h5
              className="font-semibold mb-5"
              style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.78rem', letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.45)' }}>

              Navegação
            </h5>
            <ul className="space-y-2.5">
              {[
              { label: 'Iniciar Diagnóstico', href: '/multi-step-questionnaire' },
              { label: 'Sobre a GestPub', href: 'https://www.gestpub.pt/sobre-nos/' },
              { label: 'GP Otimiza', href: 'https://www.gestpub.pt/gp-otimiza/' },
              { label: 'Serviços', href: 'https://www.gestpub.pt/servicos/' },
              { label: 'Contactos', href: 'https://www.gestpub.pt/contactos/' }]?.
              map((link) =>
              <li key={link?.label}>
                  <a
                  href={link?.href}
                  className="transition-colors duration-200"
                  style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.85rem', color: 'rgba(255,255,255,0.55)' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#FFFFFF'}
                  onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.55)'}>

                    {link?.label}
                  </a>
                </li>
              )}
            </ul>
          </div>

          {/* Contact column */}
          <div>
            <h5
              className="font-semibold mb-5"
              style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.78rem', letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.45)' }}>

              Contacto
            </h5>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5" style={{ color: 'rgba(255,255,255,0.55)' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="mt-0.5 flex-shrink-0" aria-hidden="true">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.82rem', lineHeight: 1.5 }}>
                  Avenida da República, Ed. República, 1º Piso,<br />
                  Escritório E, Alcoitão | 2645-143 Estoril
                </span>
              </li>
              <li className="flex items-center gap-2.5">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.55)" strokeWidth="2" aria-hidden="true">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <a
                  href="mailto:geral@gestpub.pt"
                  className="transition-colors duration-200"
                  style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.82rem', color: '#009688' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#FFFFFF'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#009688'}>

                  geral@gestpub.pt
                </a>
              </li>
              <li className="flex items-center gap-2.5" style={{ color: 'rgba(255,255,255,0.55)' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 014.69 13a19.79 19.79 0 01-3.07-8.67A2 2 0 013.6 2.18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L7.91 9.91a16 16 0 006.06 6.06l1.79-1.79a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                </svg>
                <a
                  href="tel:+351214846546"
                  className="transition-colors duration-200"
                  style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.82rem', color: 'rgba(255,255,255,0.55)' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#FFFFFF'}
                  onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.55)'}>

                  (+351) 214 846 546
                </a>
              </li>
              <li className="flex items-center gap-2.5" style={{ color: 'rgba(255,255,255,0.55)' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 014.69 13a19.79 19.79 0 01-3.07-8.67A2 2 0 013.6 2.18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L7.91 9.91a16 16 0 006.06 6.06l1.79-1.79a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                </svg>
                <a
                  href="tel:+351926687439"
                  className="transition-colors duration-200"
                  style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.82rem', color: 'rgba(255,255,255,0.55)' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#FFFFFF'}
                  onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.55)'}>

                  (+351) 926 687 439
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t" style={{ borderColor: 'rgba(255,255,255,0.1)' }} />

        {/* Group line */}
        <div className="pt-6 mb-4">
          <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.78rem', color: 'rgba(255,255,255,0.4)' }}>
            <strong style={{ color: 'rgba(255,255,255,0.6)' }}>GRUPO:</strong>{' '}
            <a
              href="https://www.gestpme.pt"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors duration-200"
              style={{ color: '#009688' }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#FFFFFF'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#009688'}>

              GestPME, Gestão e Consultoria Empresarial
            </a>
            {' | '}
            <a
              href="https://www.gestpub.pt"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors duration-200"
              style={{ color: '#009688' }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#FFFFFF'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#009688'}>

              GestPub, Gestão Pública e Consultoria Autárquica
            </a>
          </p>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.78rem', color: 'rgba(255,255,255,0.35)' }}>
            &copy; {currentYear} GestPub – Gestão Pública e Consultoria Autárquica. Todos os direitos reservados.
          </p>
          <div className="flex gap-6">
            {[
            { label: 'Política de Privacidade', href: '/politica-de-privacidade' },
            { label: 'Termos de Utilização', href: '/termos-de-utilizacao' },
            { label: 'RGPD', href: '/rgpd' }]?.
            map((link) =>
            <Link
              key={link?.label}
              href={link?.href}
              className="transition-colors duration-200"
              style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.78rem', color: 'rgba(255,255,255,0.35)' }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#FFFFFF'}
              onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.35)'}>

                {link?.label}
              </Link>
            )}
          </div>
        </div>
      </div>
    </footer>);

}